export default __webpack_public_path__ + "static/media/LohithTummala.ee32d974.png";